module.exports = __webpack_public_path__ + "static/img/newFood3.034a95e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newFood3.png
// module id = PPGC
// module chunks = 2